/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum SmsAddonFailureReason {
  NOT_GROWTH="NOT_GROWTH",
NO_STRIPE_SUB="NO_STRIPE_SUB",
MISSING_CONFIGURATION="MISSING_CONFIGURATION",
STRIPE_ERROR="STRIPE_ERROR"
}

/**
* SmsAddonFailureReason
*/
export const SmsAddonFailureReasonEnumType = types.enumeration("SmsAddonFailureReason", [
        "NOT_GROWTH",
  "NO_STRIPE_SUB",
  "MISSING_CONFIGURATION",
  "STRIPE_ERROR",
      ])
